// What the PLAIN Canvas call adds for a project without a canvas (CR-20261009-001 L3.3 / L3.4, D555 A = L3-D1 A): the
// host's live-assist panel and the site camera, which before lived only in the navigator. Pure decisions, so the rules are
// pinned in tests/unit/call-assist-site.test.mjs; call.js only wires them.
//
// A meeting Helix stamps NULL (no siteVia/brand on the link answer — every meeting a Mana sales manager hosts) gets
// nothing from here: today's call, byte for byte (D532 A). The words come from the meeting's record, never a switch.
import { isSite, notSite, rmHosted } from "./canvas/privacy.js";

// `canvasProduct`: product.js isCanvas (canvas.clikhome.in, not ClikMeet). `inRoom`: a ClikMeet room's call (link answer).
export function callExtras({ meeting, role, canvasProduct, inRoom }) {
  const m = meeting || {};
  // Canvas's plain call: the Canvas product, no canvas (with one the navigator and her canvas page run instead), and
  // never a ClikMeet room.
  const plain = Boolean(canvasProduct) && !inRoom && !m.roomCode && !m.canvas;
  const rm = plain && rmHosted(m);
  const host = role === "host";
  const viewer = role === "customer" || role === "guest";
  return {
    // The host's alone, and only when the meeting has assist (the studio turns it on for an RM-hosted meeting with a
    // project code; a NULL meeting without a canvas never has it).
    assistPanel: plain && host && Boolean(m.assist),
    // The host's Site camera box: the live link Helix made (only Helix makes it, L3.4), who is on it, Show it / Back.
    siteBox: rm && host,
    // Whether a site-* person is ours to place: off the grid unless the host has put them on the stage.
    siteStage: rm && role !== "site",
    // Her page and a guest's: the site phone may subscribe to the microphone only (L3.1 guardTracks).
    guard: rm && viewer,
    // Chat and reactions skip the site phone.
    quietToSite: rm,
  };
}

// LiveKit stamps every message with its sender's identity and blanks it only for a hidden sender (the assist): a
// message that names a sender came from someone in the meeting, and is dropped — as the navigator does.
export const acceptAssist = (from) => !(from && from.identity);

// The site camera on the stage, from the HOST's state ({cam}) only, and only a site-* identity in the room.
export function siteCamFrom(body, senderIdentity, presentIdentities) {
  if (!String(senderIdentity || "").startsWith("host-")) return null;
  const cam = body && typeof body === "object" && typeof body.cam === "string" ? body.cam : null;
  if (!cam || !isSite(cam)) return null;
  return (presentIdentities || []).includes(cam) ? cam : null;
}

// Whether this screen shows a person's camera tile. Anyone not a site phone: as today. A site phone: the host always
// (he decides to show it); everyone else only while it is on the stage.
export function siteVisibleTo(extras, identity, cam) {
  if (!extras?.siteStage || !isSite(identity)) return true;
  if (extras.siteBox) return true;
  return cam === identity;
}

// Who a chat line or reaction goes to: undefined = everyone (today); a list = everyone but the site phone. An empty list
// sends nothing (LiveKit reads an empty list as everyone).
export function chatTargets(extras, identities) {
  if (!extras?.quietToSite) return undefined;
  return notSite({ remoteParticipants: new Map((identities || []).map((i) => [i, { identity: i }])) });
}
